import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LoginPage from '@/pages/LoginPage';
import EmployeeHome from '@/pages/EmployeeHome';
import EmployeeHistory from '@/pages/EmployeeHistory';
import EmployeeProfile from '@/pages/EmployeeProfile';
import EmployeeLeaves from '@/pages/EmployeeLeaves';
import AdminDashboard from '@/pages/AdminDashboard';
import AdminDailySummary from '@/pages/AdminDailySummary';
import AdminEmployees from '@/pages/AdminEmployees';
import AdminEmployeeDetail from '@/pages/AdminEmployeeDetail';
import AdminAnalytics from '@/pages/AdminAnalytics';
import AdminLeaves from '@/pages/AdminLeaves';
import AdminHolidays from '@/pages/AdminHolidays';
import AdminZones from '@/pages/AdminZones';
import AdminLateSanctions from '@/pages/AdminLateSanctions';
import AdminWorkPermissions from '@/pages/AdminWorkPermissions';
import AdminSettings from '@/pages/AdminSettings';
import AdminBranches from '@/pages/AdminBranches';
import AdminRMs from '@/pages/AdminRMs';
import AdminAuditTrail from '@/pages/AdminAuditTrail';
import AdminDesignations from '@/pages/AdminDesignations';
import RMDashboard from '@/pages/RMDashboard';
import EmployeeNotifications from '@/pages/EmployeeNotifications';

function ProtectedRoute({ children, role }) {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (!token) return <Navigate to="/" replace />;
  if (role && user.role !== role) {
    const dest = user.role === 'admin' ? '/admin' : user.role === 'rm' ? '/rm' : '/employee';
    return <Navigate to={dest} replace />;
  }
  return children;
}

function App() {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }
  }, []);

  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/employee" element={<ProtectedRoute role="employee"><EmployeeHome /></ProtectedRoute>} />
          <Route path="/employee/history" element={<ProtectedRoute role="employee"><EmployeeHistory /></ProtectedRoute>} />
          <Route path="/employee/profile" element={<ProtectedRoute role="employee"><EmployeeProfile /></ProtectedRoute>} />
          <Route path="/employee/leaves" element={<ProtectedRoute role="employee"><EmployeeLeaves /></ProtectedRoute>} />
          <Route path="/employee/notifications" element={<ProtectedRoute role="employee"><EmployeeNotifications /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/daily-summary" element={<ProtectedRoute role="admin"><AdminDailySummary /></ProtectedRoute>} />
          <Route path="/admin/employees" element={<ProtectedRoute role="admin"><AdminEmployees /></ProtectedRoute>} />
          <Route path="/admin/employees/:id" element={<ProtectedRoute role="admin"><AdminEmployeeDetail /></ProtectedRoute>} />
          <Route path="/admin/zones" element={<ProtectedRoute role="admin"><AdminZones /></ProtectedRoute>} />
          <Route path="/admin/leaves" element={<ProtectedRoute role="admin"><AdminLeaves /></ProtectedRoute>} />
          <Route path="/admin/late-sanctions" element={<ProtectedRoute role="admin"><AdminLateSanctions /></ProtectedRoute>} />
          <Route path="/admin/work-permissions" element={<ProtectedRoute role="admin"><AdminWorkPermissions /></ProtectedRoute>} />
          <Route path="/admin/holidays" element={<ProtectedRoute role="admin"><AdminHolidays /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute role="admin"><AdminAnalytics /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute role="admin"><AdminSettings /></ProtectedRoute>} />
          <Route path="/admin/audit-trail" element={<ProtectedRoute role="admin"><AdminAuditTrail /></ProtectedRoute>} />
          <Route path="/admin/branches" element={<ProtectedRoute role="admin"><AdminBranches /></ProtectedRoute>} />
          <Route path="/admin/rms" element={<ProtectedRoute role="admin"><AdminRMs /></ProtectedRoute>} />
          <Route path="/admin/designations" element={<ProtectedRoute role="admin"><AdminDesignations /></ProtectedRoute>} />
          <Route path="/rm" element={<ProtectedRoute role="rm"><RMDashboard /></ProtectedRoute>} />
          <Route path="/rm/*" element={<ProtectedRoute role="rm"><RMDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
